// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.academics-pagination {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: #FAFAFA;
  border-top: 1px solid #EBEBEB;
  padding: 8px 12px;
  margin-top: 0;
}

.academics-pagination .ant-pagination {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.academics-pagination .ant-pagination-total-text {
  margin-right: auto;
  color: #475569;
  font-size: 13px;
}

.academics-pagination .ant-pagination-options {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./pages/academics/academics.css"],"names":[],"mappings":"AAAA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".academics-pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  background: #FAFAFA;\r\n  border-top: 1px solid #EBEBEB;\r\n  padding: 8px 12px;\r\n  margin-top: 0;\r\n}\r\n\r\n.academics-pagination .ant-pagination {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.academics-pagination .ant-pagination-total-text {\r\n  margin-right: auto;\r\n  color: #475569;\r\n  font-size: 13px;\r\n}\r\n\r\n.academics-pagination .ant-pagination-options {\r\n  margin-left: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
